import React, { useState } from 'react';
import {
  IconButton,
  Box,
  useTheme,
  List,
  ListItemButton,
  ListItemText,
  Link as MuiLink
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { motion, AnimatePresence } from 'framer-motion';

const menuItems = [
  { label: 'Home', to: '/' },
  { label: 'Booking', to: '/booking' },
  { label: 'About', to: '/about' },
  { label: 'FAQ', to: '/faq' }
];

const overlayVariants = {
  hidden: { opacity: 0 },
  visible: { 
    opacity: 1, 
    transition: { when: 'beforeChildren', staggerChildren: 0.1 } 
  },
  exit:   { opacity: 0, transition: { when: 'afterChildren' } },
};

const itemVariants = {
  hidden:  { y: '100%', opacity: 0 },
  visible: { y: '0%',   opacity: 1, transition: { duration: 0.8, ease: 'easeOut' } },
  exit:    { y: '100%', opacity: 0, transition: { duration: 0.5 } },
};

export default function HamburgerMenu() {
  const theme = useTheme();
  const [open, setOpen] = useState(false);

  // zIndex values
  const OPEN_BTN_Z = theme.zIndex.modal + 1;
  const OVERLAY_Z  = theme.zIndex.modal + 2;

  return (
    <>
      {/* only show “hamburger” when menu is closed */}
      {!open && (
        <IconButton
          onClick={() => setOpen(true)}
          sx={{
            position: 'fixed',
            top: 16,
            right: 16,
            zIndex: OPEN_BTN_Z,
            color: '#d89936',
          }}
          aria-label="Open menu"
        >
          <MenuIcon fontSize="large" />
        </IconButton>
      )}

      <AnimatePresence>
        {open && (
          <motion.div
            variants={overlayVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              backgroundColor: theme.palette.background.default,
              zIndex: OVERLAY_Z,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {/* close button */}
            <IconButton
              onClick={() => setOpen(false)}
              sx={{
                position: 'absolute',
                top: 16,
                right: 16,
                color: theme.palette.text.primary,
                zIndex: OVERLAY_Z + 1,
              }}
              aria-label="Close menu"
            >
              <CloseIcon fontSize="large" />
            </IconButton>

            <List>
              {menuItems.map(({ label, to }) => (
                <motion.div key={label} variants={itemVariants}>
                  <ListItemButton
                    component={MuiLink}
                    href={to}
                    onClick={() => setOpen(false)}
                    sx={{
                      py: 2,
                      px: 4,
                      textAlign: 'center',
                    }}
                  >
                    <ListItemText
                      primary={label}
                      primaryTypographyProps={{
                        variant: 'h4',
                        fontWeight: 'bold',
                        color: '#193e2d',
                        fontFamily: 'lulo-one'
                      }}
                    />
                  </ListItemButton>
                </motion.div>
              ))}
            </List>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}